import { toast } from "react-toastify";

/**
 * A transaction row belongs to a split group when it carries a
 * `split_group_id`. Split groups must be deleted as a whole (via the edit
 * dialog), so bulk-delete flows exclude these rows.
 */
export function isSplitTransaction(
  row: { split_group_id?: string } | null | undefined
): boolean {
  return !!(row as { split_group_id?: string } | null | undefined)
    ?.split_group_id;
}

/**
 * Warn the user that split transactions were excluded from a bulk delete.
 * No-op when nothing was skipped.
 */
export function notifySkippedSplitTransactions(count: number): void {
  if (count > 0) {
    toast.warning(
      `${count} split transaction(s) were skipped. Split transactions must be deleted individually.`
    );
  }
}
